import React, { useEffect } from 'react';
import PageHeader from '../innovher/PageHeader';
import { IMG } from '../../lib/images';
import SEO from '../SEO';

export default function D2cSummitPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const els = document.querySelectorAll('.reveal-up');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const gallery = [
    IMG.eventD2c1, // 0: 2x2
    IMG.eventD2c2, // 1: 2x2
    IMG.eventD2c3, // 2: 1x1
    IMG.eventD2c4, // 3: 1x1
    IMG.eventD2c5, // 4: 1x1
    IMG.eventD2c6, // 5: 1x1
    IMG.eventD2c7, // 6: 2x1
    IMG.eventD2c8  // 7: 2x1
  ];

  return (
    <>
      <SEO 
        title="D2C Innovation Summit | InnovHer Event"
        description="The D2C Innovation Summit by InnovHer in Jaipur brought together founders, visitors and industry leaders around Direct-to-Consumer business."
        keywords="D2C Innovation Summit, Jaipur D2C event, InnovHer summit, Rajasthan startups"
      />
      <PageHeader
        eyebrow="Signature Event"
        title={<><span className="text-[#ff8ec5]">D2C Innovation Summit</span> 2024</>}
        subtitle="Hosted by Innovher in partnership with FORHEX supported by I-Start & MeitY, was a groundbreaking event held from August 9th to 12th, 2024, at the prestigious Forhex Fair in Jaipur."
        image={IMG.eventD2c2}
        breadcrumbs={[{ label: 'Events', to: '#' }, { label: 'D2C Summit' }]}
      />

      <section className="relative bg-[#08080a] py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          
          <div className="reveal-up max-w-4xl mx-auto text-center mb-24">
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-8">A Hub of Innovation and Collaboration</h2>
            <p className="text-lg text-white/60 leading-relaxed text-justify md:text-center">
              This summit marked a significant milestone as Rajasthan’s first-ever event dedicated to fostering innovation and collaboration within the Direct-to-Consumer (D2C) sector. The summit was a melting pot of industry leaders, skilled craftsmen, artisans, and aspiring entrepreneurs, all converging to shape the future of D2C business. The D2C Innovation Summit attracted over 35,000 visitors, offering a unique platform for startups to connect directly with their target audience, refine their Product Market Fit (PMF), and accelerate their business growth. With participation from over 200 exporters, 500+ vendors, and 100+ government officials, the summit provided unparalleled networking and business opportunities. It was an event where the D2C approach truly came to life, bringing together founders, mentors, investors, and customers dedicated to turning innovative ideas into successful businesses.
            </p>
          </div>

          <div className="reveal-up">
            <h3 className="text-2xl font-bold text-white mb-8 border-l-4 border-[#ff8ec5] pl-4">Event Gallery</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[250px] md:auto-rows-[300px] gap-4 md:gap-6">
              {gallery.map((src, i) => {
                const getBentoClasses = (index) => {
                  switch(index) {
                    case 0: return "md:col-span-2 md:row-span-2";
                    case 1: return "md:col-span-2 md:row-span-2";
                    case 6: return "md:col-span-2 md:row-span-1";
                    case 7: return "md:col-span-2 md:row-span-1";
                    default: return "md:col-span-1 md:row-span-1";
                  }
                };
                
                return (
                <div key={i} className={`relative group rounded-3xl overflow-hidden bg-white/5 border border-white/10 ${getBentoClasses(i)}`}>
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none" />
                  <img 
                    src={src} 
                    alt={`D2C Summit Gallery ${i + 1}`} 
                    className="absolute inset-0 w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700" 
                    loading="lazy"
                  />
                </div>
              )})}
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
